import { render, staticRenderFns } from "./RentalPayments.vue?vue&type=template&id=6a451270&scoped=true&"
import script from "./RentalPayments.vue?vue&type=script&lang=ts&"
export * from "./RentalPayments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a451270",
  null
  
)

export default component.exports